export const formatNumber = (num: number | undefined | null): string => {
  if (num === undefined || num === null || isNaN(num)) return '0';
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
};

export const formatPercentage = (value: number, total: number): string => {
  if (total === 0) return '0%';
  return `${((value / total) * 100).toFixed(1)}%`;
};

export const calculateTrend = (
  current: number,
  previous: number
): {
  value: number;
  isPositive: boolean;
  percentage: string;
} => {
  if (previous === 0) {
    return { value: 100, isPositive: current > 0, percentage: '+100%' };
  }
  const diff = current - previous;
  const percentage = (diff / previous) * 100;
  return {
    value: Math.abs(percentage),
    isPositive: diff >= 0,
    percentage: `${diff >= 0 ? '+' : ''}${percentage.toFixed(1)}%`,
  };
};

export const CHART_COLORS = {
  primary: 'hsl(var(--primary))',
  success: 'hsl(142.1 76.2% 36.3%)',
  warning: 'hsl(37.7 92.1% 50.2%)',
  danger: 'hsl(0 84.2% 60.2%)',
  purple: 'hsl(262.1 83.3% 57.8%)',
  plans: {
    free: 'hsl(215.4 16.3% 46.9%)',
    basic: 'hsl(221.2 83.2% 53.3%)',
    pro: 'hsl(262.1 83.3% 57.8%)',
    premium: 'hsl(37.7 92.1% 50.2%)',
  },
  gradient: {
    from: 'hsl(var(--primary))',
    to: 'hsl(221.2 83.2% 43.3%)',
  },
};
